<template>
	<section>

	
	<div v-if="!isTaskRoute">
		<header-page
				name="levels"
				:title="$route.meta.title"
			/>
		<div>
			<v-layout pl-5 pt-3>
				<v-flex xs3 ml-3>
					<v-select background-color="white" class="body-1 mt-2" box hide-details  clearable item-text="description"
						item-value="id" label="Rubro" :items="items" v-model="params.itemId"
					></v-select>
				</v-flex>
				<v-flex xs3 ml-3>
					<v-select background-color="white" class="body-1 mt-2" box hide-details clearable item-text="name"
						item-value="id" label="Plan" :items="typePlans" v-model="params.typePlan"
					></v-select>
				</v-flex>
			</v-layout>
		</div>
		<div class="px-5">
			<app-table class="my-5 is-not-selectable pb-4" name="projects" :columns="columns" :current-page="currentPage"
				:rows="rows" :last-page="lastPage" @on-search-event="onSearch" @on-page="changePage">
				<template slot="rows" slot-scope="props">
						<td
							class="is-not-selectable"
							v-show="showRow(columns, 1)"
						>
							{{ props.row.levelOrder }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.name }} 
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.item.data.name }}
						</td>
						<td v-show="showRow(columns, 4)">
							{{ props.row.planName ? props.row.planName : 'Sin Plan' }}
						</td>
						<td v-show="showRow(columns, 5)" class="d-flex align-center">
							<app-tooltip-button
								color="blue"
								icon="visibility"
								text="Tareas"
								@click-icon="tasks(props.row)"
							/>
							<app-tooltip-button
								color="blue"
								icon="edit"
								text="Editar"
								@click-icon="edit(props.row)"
							/>
							
							<app-tooltip-button
								color="red"
								icon="delete"
								text="Eliminar"
								@click-icon="openModalConfirmation(props.row)"
							/>
							<v-tooltip top>
								<v-switch
									slot="activator"
									color="green"
									class="mt-0 ml-2"
									hide-details
									v-model="props.row.flagActive"
									@change="blockedLevel(props.row)"
								></v-switch>
								<span class="text-center">{{ props.row.flagActive ? 'Desactivar' : 'Activar' }} nivel</span>
							</v-tooltip>
							
						</td>
					</template>
			</app-table>
		</div>
		<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
	</div>
	<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	<router-view></router-view>

	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function openModal() {
	this.goTo('page-new-levels');
}
function edit({ id }) {
	this.goTo('page-edit-levels', { params: { id } });
}
function tasks({ id }) {
	this.goTo('page-tasks-level', { params: { id, codeProject: this.codeProject } });
}

async function confirm() {
	try {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		await this.$http.delete(`level/${this.modalConfirmation.selectedRow.id}`, { headers });
		this.showNotification('El nivel se elimino correctamente');
		this.cancelModalConfirmation();
		this.loadData();
	} catch (error) {
		this.showError();
	}
}

async function loadData() {
	try {
		const params = { ...this.params };
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		params.typePlan = params.typePlan === null ? 'null' : params.typePlan;
		const response = await this.$http.get('level', { params, headers });
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}
function created() {
	this.loadData();
	this.loadPlans();
	this.loadItems();
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'LVL',
				text: 'Agregar Nivel',
				img: '',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Nivel', checked: true, visible: true },
			{ id: 2, name: 'Nombre', checked: true, visible: true },
			{ id: 3, name: 'Rubro', checked: true, visible: true },
			{ id: 4, name: 'Plan', checked: true, visible: true },
			{ id: 5, name: '', checked: true, visible: true, flagVisible: true },
		],
		items: [],
		typePlans: [],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		loading: false,
		params: {
			page: 1,
			codeProject: this.codeProject,
			itemId: null,
			typePlan: undefined,
		},
	};
}

export default {
	name: 'page-levels',
	data,
	created,
	components: {
		appTooltipButton,
		quickActions,
		appConfirmationModal,
	},
	computed: {
		isTaskRoute() {
			return this.$route.name && this.$route.name.includes('task');
		},
	},
	methods: {
		openModal,
		edit,
		loadData,
		changePage,
		onSearch,
		tasks,
		confirm,
		async loadPlans() {
			const response = await this.$http.get('type-plans');
			this.typePlans = response.data.data;
			this.typePlans.unshift({ id: null, name: 'Sin Plan' });
		},
		async loadItems() {
			const response = await this.$http.get(`project/${this.codeProject}/items`);
			this.items = response.data.data;
		},
		async blockedLevel(row) {
			const { flagActive, id, itemId, levelOrder, name } = row;
			const message = flagActive ? 'activo' : 'desactivo';
			const body = {
				flagActive: flagActive ? 1 : 0,
				itemId,
				levelOrder,
				name
			};
			const headers = {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			};
			try {
				await this.$http.patch(`level/${id}`, body, { headers });
				this.showNotification(`Se ${message} el nivel`);
			} catch (error) {
				this.showNotification('No se pudo bloquear el nivel', 'error');
			}
		},
	},
	props: {
		codeProject: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-levels') {
					this.loadData();
				}
			}
		},
		params: {
			handler(newVal) {
				if (newVal) {
					this.loadData();
				}
			},
			deep: true
		}
	},
};

</script>


// WEBPACK FOOTER //
// src/pages/levels/page-levels.vue